var Editor=require('./Editor');
var $ = require('jQuery');
var html2Text = require('../../../utils/html2Text');
var PlainText=function(options){
    var defaults = {
        template:'<textarea class="im-input-plaintext"></textarea>'
    };
    $.extend(defaults, options);
    Editor.call(this, defaults);
};
PlainText.prototype=Object.create(Editor.prototype);
PlainText.prototype.clear = function () {
    this._element.val('');
};
PlainText.prototype.get = function () {
    return {
        type: 'text',
        msg: this._element.val()
    };
};
PlainText.prototype.update = function (value, options) {
    var is_emotion = options && options.is_emotion;
    var oldValue = this.get().msg;
    var need_html_2 = is_emotion || (options && options.need_html_2);
    this._element.val(oldValue + (need_html_2 ? value : html2Text(value)));
};


module.exports=PlainText;